import type { SVGProps } from 'react'

interface BlockchainIconProps extends SVGProps<SVGSVGElement> {}

export function BlockchainIcon(props: BlockchainIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 416.33 416.33"
      {...props}
      fill="currentColor"
    >
      <path d="M187.4 130.25h45.19v-21.43c0-7.96 9.93-15.86 17.45-16.44 18.51-1.42 38.78 1.05 57.47 0 8.88 1.27 15.6 8.28 16.78 17.11l-.03 59.44c-1.1 7.61-8.72 15.82-16.74 15.82h-23.09v47.18h24.75c6.96 0 14.98 9.61 15.11 16.45v59.47c-1.35 8.26-8.11 14.82-16.45 15.78l-58.43-.04c-7.98-.06-16.82-9.71-16.82-17.4v-23.42H187.4v24.09c0 7.44-8.07 15.99-15.49 16.74-18.48-.17-38.37 1.51-56.77.37-9.3-.57-18.22-6.56-19.1-16.45-1.52-16.91 1.11-36.03.01-53.17-2.91-8.43 5.85-22.41 14.77-22.41h24.42v-47.18h-22.76c-7.8 0-15.69-8.22-16.41-15.82l-.04-61.43c1.53-8 8.64-14.45 16.79-15.11 18.43-1.5 38.83 1.11 57.47 0 7.72.07 17.12 9.52 17.12 17.11v20.77zm45.19 12.96H187.4v25.09c0 5.97-6.91 13.68-12.39 15.52-5.04 1.69-19.76 1.13-25.67.94-.64-.02-1.2-.26-1.81-.35v47.51h24.42c7.04 0 15.45 9.98 15.45 16.78v21.76h44.69c.1 0 .25.42.5.33v-22.76c0-6.46 8.83-16.11 15.45-16.11h24.09v-47.18c-11.63-1.02-27.43 3.65-35.5-7.2-1.65-2.22-4.04-7.88-4.04-10.58V143.2z" />
    </svg>
  )
}
